import secureLocalStorage from "react-secure-storage";

export default function StructFunctionality ( mockData, newData, storageItem )
{
  // get item stored data
  let storedDataString = secureLocalStorage.getItem( storageItem );

  // check if stored data exist
  if ( storedDataString ) {

    // convert stored data to object
    let storedData = JSON.parse( storedDataString );

    let merge = merge_obj( storedData, newData );

    if ( storedData !== merge ) {
      secureLocalStorage.setItem( storageItem, JSON.stringify( merge ) );
    }

    return merge;

  // no stored data ...
  } else {

    // has new data to insert before storing and returning
    if ( Object.keys( newData ).length !== 0 ) {
      // merge new data with old one
      mockData = { ...mockData, ...newData };
      secureLocalStorage.setItem( storageItem, JSON.stringify( mockData ) );

    } else {
      return mockData;
    }
  }
}

export function merge_obj ( _old, _new )
{
    // check if _new has data that can substitute _old
    if ( Object.keys( _new ).length !== 0 ) {
      // loop _new and check for value differences
      Object.keys( _new ).forEach(( k, i ) => {
        // check if _old[k] and _new[k] has differences
        // if has differences substitute with new data
        if ( _old[k] !== _new[k] ) {
          // merge objects
          _old = { ..._old, ..._new };
        }
        // no differences found, return original data
      });
      return _old;
    // newData is empty return original data
    } else {
        return _old;
    }
}

export function forget ( storageItem ) {
  secureLocalStorage.removeItem( storageItem );
}
